'use strict';

module.exports = require('./Tooltip');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.3.4.3@rc-tooltip/lib/index.js
 ** module id = 544
 ** module chunks = 0 1
 **/